import { render, staticRenderFns } from "./CarrierInpost.vue?vue&type=template&id=66df12c0&"
import script from "./CarrierInpost.vue?vue&type=script&lang=js&"
export * from "./CarrierInpost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports